import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';
import Button, { ButtonSize } from '../../../../../atoms/buttons/Button';
import css from './PurchaseBackToTop.module.scss';

interface ElementProps {
  publicId: string;
}

type Props = ElementProps;

const PurchaseBackToTop: React.FC<Props> = (props) => {
  const { publicId } = props;
  const intl = useIntl();
  const classes = classNames(css.PurchaseBackToTop);

  return (
    <div className={classes}>
      <Button
        isGhost={true}
        isFull={true}
        buttonSize={ButtonSize.Medium}
        href={`/${publicId}`}
      >
        {intl.formatMessage({
          id: 'purchases.purchaseBackToTop.submitButton',
        })}
      </Button>
    </div>
  );
};

export default PurchaseBackToTop;
